/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Level_RejectedInputs */

const en_usage_level_rejected = /** @type {(inputs: Usage_Level_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejected`)
};

const zh_hans1_usage_level_rejected = /** @type {(inputs: Usage_Level_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已拒绝`)
};

const pt_br2_usage_level_rejected = /** @type {(inputs: Usage_Level_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejeitada`)
};

const es_usage_level_rejected = /** @type {(inputs: Usage_Level_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazada`)
};

const fr_usage_level_rejected = /** @type {(inputs: Usage_Level_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rejeté`)
};

const de_usage_level_rejected = /** @type {(inputs: Usage_Level_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abgelehnt`)
};

const ru_usage_level_rejected = /** @type {(inputs: Usage_Level_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отклонён`)
};

const it_usage_level_rejected = /** @type {(inputs: Usage_Level_RejectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rifiutata`)
};

/**
* | output |
* | --- |
* | "Rejected" |
*
* @param {Usage_Level_RejectedInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_level_rejected = /** @type {((inputs?: Usage_Level_RejectedInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Level_RejectedInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_level_rejected(inputs)
	if (locale === "pt-BR") return pt_br2_usage_level_rejected(inputs)
	if (locale === "es") return es_usage_level_rejected(inputs)
	if (locale === "fr") return fr_usage_level_rejected(inputs)
	if (locale === "de") return de_usage_level_rejected(inputs)
	if (locale === "ru") return ru_usage_level_rejected(inputs)
	if (locale === "it") return it_usage_level_rejected(inputs)
	return en_usage_level_rejected(inputs)
});